<red-header-content id="filter-header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Sort & Filter</ion-title>
    <ion-buttons slot="primary">
      <ion-button (click)="clearFilters()">
        Clear <ion-icon slot="end" name="backspace-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</red-header-content>
<red-page-content [paddingBottom]="true">
  <form [formGroup]="filterForm">
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>Sort By</ion-label>
      </ion-list-header>
      <ion-item (click)="sortBy(walkingFarmPropertiesSortBy.ParcelNumber)" [button]="true" [detail]="false">
        Parcel Number
        <ion-icon slot="end" src="/assets/svg/sort-top-to-bottom.svg"></ion-icon>
      </ion-item>
      <ion-item (click)="sortBy(walkingFarmPropertiesSortBy.LeadStatus)" [button]="true" [detail]="false">
        Lead Status
        <ion-icon slot="end" src="/assets/svg/sort-top-to-bottom.svg"></ion-icon>
      </ion-item>
      <ion-item (click)="sortBy(walkingFarmPropertiesSortBy.StreetName)" [button]="true" [detail]="false">
        Street Name
        <ion-icon slot="end" src="/assets/svg/sort-top-to-bottom.svg"></ion-icon>
      </ion-item>
      <ion-item (click)="sortBy(walkingFarmPropertiesSortBy.UnreadAlerts)" [button]="true" [detail]="false">
        Unread Alerts
        <ion-icon slot="end" src="/assets/svg/sort-top-to-bottom.svg"></ion-icon>
      </ion-item>
    </ion-list>
    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-list-header>
        <ion-label>Filter By</ion-label>
      </ion-list-header>
      <ion-item-divider>
        <ion-label>Owner Status</ion-label>
      </ion-item-divider>
      <ion-radio-group formControlName="filterByOwnerStatus">
        <ion-item>
          <ion-radio [value]="ownerOccupiedFilter.All">All</ion-radio>
        </ion-item>
        <ion-item>
          <ion-radio [value]="ownerOccupiedFilter.OwnerOccupied">Owner Occupied</ion-radio>
        </ion-item>
        <ion-item>
          <ion-radio [value]="ownerOccupiedFilter.NonOwnerOccupied">Non Owner Occupied</ion-radio>
        </ion-item>
        <ion-item>
          <ion-radio [value]="ownerOccupiedFilter.OutOfStateOwners">
            Out of State Owners<br />
            <ion-note color="medium" class="tw:text-xs tw:leading-4 tw:whitespace-normal">
              Properties with owners from a different state.
            </ion-note>
          </ion-radio>
        </ion-item>
        <ion-item>
          <ion-radio [value]="ownerOccupiedFilter.EmptyNesters">
            Empty Nesters
            <br />
            <ion-note color="medium" class="tw:text-xs tw:leading-4 tw:whitespace-normal">
              Properties without sale activity in the last 25 years.
            </ion-note>
          </ion-radio>
        </ion-item>
        <ion-item>
          <ion-radio [value]="ownerOccupiedFilter.YearsInHome">
            Years In Home
            <br />
            <ion-note color="medium" class="tw:text-xs tw:leading-4 tw:whitespace-normal">
              Properties that are above the median years of ownership.
            </ion-note>
          </ion-radio>
        </ion-item>
      </ion-radio-group>
      <ion-item-divider>
        <ion-label>Lead Status</ion-label>
      </ion-item-divider>
      @for (availableLeadStatus of availableLeadStatuses; track availableLeadStatus; let i = $index) {
        <ion-item formArrayName="filterByLeadStatus">
          <ion-checkbox [formControlName]="i">{{ availableLeadStatus.label }}</ion-checkbox>
          <ion-icon slot="start" name="ellipse" [style.color]="availableLeadStatus.color"></ion-icon>
        </ion-item>
      }
    </ion-list>
  </form>
</red-page-content>
